import type { Except } from '@festina-life/core'
import type { ComponentProps } from 'react'

import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawDatePicker } from './RawDatePicker'

type Props = Except<ComponentProps<typeof RawDatePicker>, 'renderInput'> &
  InputProps

export const DatePicker = ({ wrapperProps, ...fieldProps }: Props) => {
  const { internalWrapperProps, id, labelId } = createInternalWrapperPropsAndId(
    {
      wrapperProps,
      id: fieldProps.id,
    },
  )
  return (
    <RawDatePicker
      {...(!internalWrapperProps.label || fieldProps['aria-label']
        ? {}
        : { 'aria-labelledby': labelId })}
      {...fieldProps}
      id={id}
      renderInput={(input) => (
        <InputWrapper {...internalWrapperProps} labelType="reactAria">
          {input}
        </InputWrapper>
      )}
    />
  )
}
